import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Fab from "@mui/material/Fab";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { themeStyle } from "../../components/Components";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import GavelIcon from "@mui/icons-material/Gavel";
import BallotIcon from "@mui/icons-material/Ballot";
import ComputerIcon from "@mui/icons-material/Computer";
import HistoryIcon from "@mui/icons-material/History";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PublicIcon from "@mui/icons-material/Public";
import CalculateIcon from "@mui/icons-material/Calculate";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const colorList = [
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
];
const colorList2 = [
  "#2ca25f",
  "#8856a7",
  "#e34a33",
  "#1c9099",
  "#636363",
  "#c51b8a",
  "#756bb1",
  "#31a354",
  themeStyle.primaryColor,
  "#e6550d",
];

const colorList3 = [
  "#99d8c9",
  "#9ebcda",
  "#fdbb84",
  "#a6bddb",
  "#bdbdbd",
  "#fa9fb5",
  "#bcbddc",
  "#addd8e",
  "#9ecae1",
  "#a1d99b",
];

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function getIcon(subject) {
  var sub = subject.toLowerCase();
  if (sub.includes("break") || sub.includes("lunch")) {
    return <LocalDiningIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("mechanic")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("social")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("civics")) {
    return <GavelIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("polit")) {
    return <BallotIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("compu")) {
    return <ComputerIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("bio")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("chem") || sub.includes("scien")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("economics") ||
    sub.includes("accou") ||
    sub.includes("busi")
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("geom") ||
    sub.includes("archi") ||
    (sub.includes("engg") && sub.includes("draw"))
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("geo")) {
    return <PublicIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("math")) {
    return <CalculateIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("history")) {
    return <HistoryIcon style={{ fontSize: 45, color: "black" }} />;
  } else {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  }
}

function Timetable() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [select, setSelect] = useState("EVENTS");
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({});
  const [classList, setClassList] = useState({});
  const [semesterList, setSemesterList] = useState([]);

  const handleSelect = (value) => {
    setSelect(value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;

    axios
      .post(API_URL + "/get_class_list", JSON.stringify(body), config)
      .then((res) => {
        console.log(res.data);
        var classListTemp = res.data;
        setClassList(classListTemp);
        setCurrentSemester(
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ],
          )[0],
        );
        setSemesterList(
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ],
          ),
        );

        setClass(Object.keys(classListTemp)[0]);
        setDivision(
          Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
        );

        getTimeTable(
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ],
          )[0],
          Object.keys(classListTemp)[0],
          Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
        );
      });
  }

  function getTimeTable(sem, cla, div) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    var body = {};
    body["institution_id"] = state.auth.user.institution_id;
    body["class_id"] = cla;
    body["division"] = div;
    body["semester"] = sem;

    body = JSON.stringify(body);
    axios
      .post(API_URL + "/get_student_time_table", body, config)
      .then((res) => {
        setTimeTable(res.data);
        if (Object.keys(res.data).length == 0) {
          setTimeTable({
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          });
        }
        setIsLoading(false);
      });
  }
  const [currentSemester, setCurrentSemester] = useState("");

  const handleSemesterChange = (e) => {
    setCurrentSemester(e.target.value);
    setSubjectList(classList[classs][division][e.target.value]);
  };

  function getSemesterList() {
    var sems = semesterList.map((sem, index) => (
      <MenuItem value={sem}>{sem}</MenuItem>
    ));

    return sems;
  }

  function getClassList() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionList() {
    var classes = Object.keys(classList[classs]).map((division, index) => (
      <MenuItem value={division}>{division}</MenuItem>
    ));
    return classes;
  }

  function handleClassChange(e) {
    setClass(e.target.value);
    setDivision(Object.keys(classList[e.target.value])[0]);
    setCurrentSemester(
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]],
      )[0],
    );

    getTimeTable(
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]],
      )[0],

      e.target.value,
      Object.keys(classList[e.target.value])[0],
    );

    setSubjectList(
      classList[e.target.value][division][
        Object.keys(
          classList[e.target.value][Object.keys(classList[e.target.value])[0]],
        )[0]
      ],
    );

    setSemesterList(
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]],
      ),
    );
  }

  function handleDivisionChange(e) {
    setDivision(e.target.value);
    setCurrentSemester(Object.keys(classList[classs][e.target.value])[0]);
    getTimeTable(currentSemester, classs, e.target.value);
    setSubjectList(
      classList[classs][e.target.value][
        Object.keys(classList[classs][e.target.value])[0]
      ],
    );
    setSemesterList(Object.keys(classList[classs][e.target.value]));
  }

  function setTimeTableItemSubject(index, subject) {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay][index]["subject"] = subject;
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function setTimeTableItemClass(index, tt_class) {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay][index]["class"] = tt_class;
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function setTimeTableItemTime(index, time) {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay][index]["time"] = time;
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function addTimeTableItem() {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay].push({
      time: "",
      subject: "",
      teacher: "",
      class: "",
    });
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function addTimeTable() {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay] = [
      {
        time: "8:00 am 8:40 am",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "8:40 am 9:20 am",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "9:20 am 9:40 am",
        subject: "Short Break",
        teacher: "",
        class: "",
      },
      {
        time: "9:40 am 10:20 am",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "10:20 am 11:00 am",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "11:00 am 11:40 am",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "11:40 am 12:20 pm",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
      {
        time: "12:20 pm 1:00 pm",
        subject: "Lunch Break",
        teacher: "",
        class: "",
      },
      {
        time: "1:00 pm 1:40 pm",
        subject: "",
        teacher: "",
        class: "",
      },
      {
        time: "1:40 pm 2:20 pm",
        subject: "",
        teacher: "",
        class: "",
        data: {},
      },
    ];
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function deleteTimeTableItem(index) {
    var tempTimeTable = timeTable;
    tempTimeTable[selectedDay].splice(index, 1);
    setTimeTable(tempTimeTable);
    setRandom(makeid(5));
  }

  function updateTimeTable() {
    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    var body = {};
    body["institution_id"] = state.auth.user.institution_id;
    body["class_id"] = classs;
    body["division"] = division;
    body["timetable"] = timeTable;
    body = JSON.stringify(body);
    axios
      .post(API_URL + "/update_time_table", body, config)
      .then((res) => {
        setIsSubmitting(false);
        setOpen(false);
        createAlert("SUCCESS", "Success.", "Timetable updated.");
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "EVENTS",
  );
  const colorList = [
    "#e5f5f9",
    "#e0ecf4",
    "#fee8c8",
    "#ece7f2",
    "#f0f0f0",
    "#fde0dd",
    "#efedf5",
    "#e5f5e0",
    themeStyle.primaryColorLight,
    "#fee6ce",
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const [timeTable, setTimeTable] = useState([]);
  const [itemIndex, setItemIndex] = useState(9999);
  const [random, setRandom] = useState("");
  const [studentList, setStudentList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [selectedDay, setSelectedDay] = useState(weekday[new Date().getDay()]);

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  var colorIndex = 0;

  function getSubjects() {
    var subjects = subjectList.map((subject, index) => (
      <MenuItem value={subject}>{Object.keys(subject)[0]}</MenuItem>
    ));
    return subjects;
  }

  function handleSubjectChange(e, index) {
    var tempTimeTable = timeTable;

    tempTimeTable[selectedDay][index]["subject"] = Object.keys(
      e.target.value,
    )[0];
    tempTimeTable[selectedDay][index]["teacher"] =
      e.target.value[Object.keys(e.target.value)[0]]["teacher"]["full_name"];
    tempTimeTable[selectedDay][index]["data"] = e.target.value;

    setTimeTable(tempTimeTable);

    setRandom(makeid(5));
  }

  function getContent() {
    return (
      <div style={{ marginTop: "-50px" }}>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <h2>
              Timetable for
              <span style={{ color: themeStyle.primaryColor }}>
                {" " + selectedDay} - {classs} {" " + division}
              </span>
            </h2>

            {timeTable[selectedDay] == "" ? (
              <Box
                height={60}
                borderRadius="6px"
                style={{
                  backgroundColor: colorList[colorIndex],
                  borderBottom: "2px solid " + colorList2[colorIndex],
                  width: "100%",
                  padding: "2px",
                }}
              >
                <div
                  style={{
                    margin: "2px 0px 0px 12px",
                    color: colorList2[colorIndex],
                    fontSize: "20px",
                  }}
                >
                  No lectures today!
                </div>
                <div
                  style={{
                    margin: "-3px 0px 0px 12px",
                    color: colorList2[colorIndex],
                    fontSize: "15px",
                  }}
                >
                  Press The " + " button to add lectures.
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                  }}
                >
                  <Fab
                    size="small"
                    style={{
                      boxShadow: "none",
                      backgroundColor: themeStyle.primaryColor,
                    }}
                    onClick={() => addTimeTableItem(selectedDay)}
                    aria-label="add"
                  >
                    <AddIcon
                      style={{
                        color: "white",
                      }}
                    />
                  </Fab>
                  <Fab
                    size="small"
                    style={{
                      marginLeft: "25px",
                      boxShadow: "none",
                      backgroundColor: themeStyle.primaryColor,
                    }}
                    onClick={() => addTimeTable(selectedDay)}
                    aria-label="add"
                  >
                    <PlaylistAddIcon
                      style={{
                        color: "white",
                      }}
                    />
                  </Fab>
                </div>
              </Box>
            ) : (
              <Fragment>
                {timeTable[selectedDay].map((lecture, index) => (
                  <Fragment>
                    <Grid
                      container
                      spacing={0}
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid md={2}>
                        {itemIndex == index ? (
                          <TextField
                            style={{
                              marginTop: "2px",
                              marginLeft: "-5px",
                              width: "200px",
                            }}
                            InputProps={{
                              textAlign: "center",
                              disableUnderline: true,
                              style: {
                                color: themeStyle.primaryColor,
                                textAlign: "center",
                              },
                            }}
                            value={lecture["time"]}
                            fullWidth
                            size="small"
                            onChange={(e) =>
                              setTimeTableItemTime(
                                index,
                                e.target.value,
                                lecture["class"],
                              )
                            }
                            placeholder={"Time"}
                            variant="outlined"
                          />
                        ) : (
                          <p
                            style={{
                              fontSize: "15px",
                              marginTop: "12px",
                              marginLeft: "10px",
                            }}
                          >
                            {lecture["time"]}
                            <span style={{ display: "none" }}>
                              {
                                (colorIndex = Math.floor(
                                  Math.random() * colorList.length,
                                ))
                              }
                            </span>
                          </p>
                        )}
                      </Grid>
                      <Grid item md={9}>
                        <Box
                          borderRadius="10px"
                          style={
                            lecture["subject"]
                              .toLowerCase()
                              .includes("break") ||
                            lecture["subject"].toLowerCase().includes("lunch")
                              ? {
                                  border: "2px solid grey",
                                  padding: "2px",
                                  display: "flex",
                                }
                              : {
                                  padding: "2px",
                                  display: "flex",
                                  padding: "2px",
                                  backgroundColor: colorList[colorIndex],
                                }
                          }
                        >
                          <div
                            style={{
                              margin:
                                lecture["subject"]
                                  .toLowerCase()
                                  .includes("break") ||
                                lecture["subject"]
                                  .toLowerCase()
                                  .includes("lunch")
                                  ? "0px 0px 0px 10px"
                                  : "2px 0px 0px 12px",
                              color: colorList2[colorIndex],
                            }}
                          >
                            {getIcon(lecture["subject"])}
                          </div>

                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            {itemIndex == index ? (
                              <TextField
                                style={{
                                  marginLeft: "10px",
                                }}
                                InputProps={{
                                  textAlign: "center",
                                  disableUnderline: true,
                                  style: {
                                    color: themeStyle.primaryColor,
                                    textAlign: "center",
                                  },
                                }}
                                value={lecture["subject"]}
                                fullWidth
                                size="small"
                                onChange={(e) =>
                                  setTimeTableItemSubject(index, e.target.value)
                                }
                                placeholder={"Subject"}
                                variant="outlined"
                              />
                            ) : (
                              <Fragment>
                                <div
                                  style={{
                                    width: "400px",
                                    margin:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "-3px 0px 0px 12px"
                                        : "0px 0px 0px 12px",
                                    color:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "black"
                                        : colorList2[colorIndex],
                                    fontSize: "20px",
                                  }}
                                >
                                  {lecture["subject"] == "Class Teacher"
                                    ? lecture["subject"] + " Period"
                                    : lecture["subject"]}
                                </div>
                              </Fragment>
                            )}

                            {itemIndex == index ? (
                              <TextField
                                style={{
                                  marginLeft: "10px",
                                }}
                                InputProps={{
                                  textAlign: "center",
                                  disableUnderline: true,
                                  style: {
                                    color: themeStyle.primaryColor,
                                    textAlign: "center",
                                  },
                                }}
                                value={lecture["class"]}
                                fullWidth
                                size="small"
                                onChange={(e) =>
                                  setTimeTableItemClass(index, e.target.value)
                                }
                                placeholder={"Classroom"}
                                variant="outlined"
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  marginRight: "20px",
                                  color:
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("break") ||
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("lunch")
                                      ? "black"
                                      : colorList2[colorIndex],
                                  fontSize: "20px",
                                }}
                              >
                                {lecture["class"]}
                              </div>
                            )}

                            {itemIndex == index ? (
                              <div style={{ marginLeft: "10px" }}>OR</div>
                            ) : (
                              ""
                            )}

                            {itemIndex == index ? (
                              <Select
                                value={timeTable[selectedDay][index]["data"]}
                                onChange={(e) => handleSubjectChange(e, index)}
                                style={{
                                  height: "40px",
                                  marginLeft: "10px",
                                  marginRight: "10px",
                                  maxWidth: "15vw",
                                }}
                                variant={"outlined"}
                              >
                                {getSubjects()}
                              </Select>
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  marginRight: "100px",
                                  color:
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("break") ||
                                    lecture["subject"]
                                      .toLowerCase()
                                      .includes("lunch")
                                      ? "black"
                                      : colorList2[colorIndex],
                                  fontSize: "20px",
                                }}
                              >
                                {timeTable[selectedDay][index]["teacher"]}
                              </div>
                            )}
                          </div>
                        </Box>
                      </Grid>
                      <Grid md={1}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {itemIndex == index ? (
                            <Button
                              onClick={() => setItemIndex(9999)}
                              style={{ borderRadius: "20px" }}
                            >
                              <SaveIcon />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => setItemIndex(index)}
                              style={{ borderRadius: "20px" }}
                            >
                              <EditIcon />
                            </Button>
                          )}

                          <Button
                            onClick={() => deleteTimeTableItem(index)}
                            style={{ borderRadius: "20px" }}
                          >
                            <DeleteIcon style={{ color: "#ff3333" }} />
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                    <br></br>
                  </Fragment>
                ))}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: themeStyle.primaryColor,
                      borderRadius: 5,
                      justifyContent: "flex-start",
                      height: "35px",
                      width: "150px",
                    }}
                    onClick={() => addTimeTableItem(selectedDay)}
                  >
                    <AddIcon
                      name="add"
                      style={{ color: "white", fontSize: "30px" }}
                    />
                    <span
                      style={{
                        textAlign: "center",
                        color: "white",
                        marginTop: "1px",
                        marginLeft: "8px",

                        fontSize: "16px",
                      }}
                    >
                      ADD ITEM
                    </span>
                  </Button>
                </div>
              </Fragment>
            )}
            <br></br>
          </Grid>
          <Grid item md={4} style={{ marginTop: "20px" }}>
            {state.auth.classType == "SEMESTERS" ? (
              <span
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                }}
              >
                Semester
              </span>
            ) : (
              ""
            )}
            {state.auth.classType == "SEMESTERS" ? (
              <Select
                style={{
                  marginTop: "2px",
                  height: "40px",
                  marginBottom: "5px",
                }}
                variant={"outlined"}
                fullWidth
                value={currentSemester}
                onChange={(e) => handleSemesterChange(e)}
              >
                {getSemesterList()}
              </Select>
            ) : (
              ""
            )}
            <br></br>
            <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Class
            </span>
            <Select
              value={classs}
              onChange={(e) => handleClassChange(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getClassList()}
            </Select>
            <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Division
            </span>
            <Select
              value={division}
              onChange={(e) => handleDivisionChange(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getDivisionList()}
            </Select>

            <Box
              borderRadius="6px"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                border: "2px solid" + themeStyle.primaryColorLight,
                padding: "10px",
                marginTop: "10px",
                alignItems: "center",
              }}
            >
              <Grid container spacing={1.5}>
                <Grid item md={4}>
                  <Button
                    style={{
                      height: "30px",
                      backgroundColor:
                        selectedDay == "Monday"
                          ? themeStyle.primaryColor
                          : "white",
                      boxShadow: "none",
                      width: "100%",

                      borderRadius: "3px",
                      fontWeight: selectedDay == "Monday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Monday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Monday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Monday" ? "contained" : ""}
                  >
                    Monday
                  </Button>
                </Grid>
                <Grid item md={4}>
                  <Button
                    style={{
                      height: "30px",
                      boxShadow: "none",
                      backgroundColor:
                        selectedDay == "Tuesday"
                          ? themeStyle.primaryColor
                          : "white",

                      width: "100%",

                      borderRadius: "3px",
                      fontWeight: selectedDay == "Tuesday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Tuesday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Tuesday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Tuesday" ? "contained" : ""}
                  >
                    Tuesday
                  </Button>
                </Grid>
                <Grid item md={4}>
                  <Button
                    style={{
                      height: "30px",
                      boxShadow: "none",
                      backgroundColor:
                        selectedDay == "Wednesday"
                          ? themeStyle.primaryColor
                          : "white",
                      width: "100%",

                      borderRadius: "3px",
                      fontWeight:
                        selectedDay == "Wednesday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Wednesday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Wednesday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Wednesday" ? "contained" : ""}
                  >
                    Wednesday
                  </Button>
                </Grid>
                <Grid item md={4}>
                  <Button
                    style={{
                      height: "30px",
                      backgroundColor:
                        selectedDay == "Thursday"
                          ? themeStyle.primaryColor
                          : "white",
                      boxShadow: "none",
                      width: "100%",

                      borderRadius: "3px",
                      fontWeight:
                        selectedDay == "Thursday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Thursday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Thursday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Thursday" ? "contained" : ""}
                  >
                    Thursday
                  </Button>
                </Grid>{" "}
                <Grid item md={4}>
                  {" "}
                  <Button
                    style={{
                      height: "30px",
                      boxShadow: "none",
                      backgroundColor:
                        selectedDay == "Friday"
                          ? themeStyle.primaryColor
                          : "white",
                      width: "100%",

                      borderRadius: "3px",
                      fontWeight: selectedDay == "Friday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Friday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Friday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Friday" ? "contained" : ""}
                  >
                    Friday
                  </Button>
                </Grid>
                <Grid item md={4}>
                  <Button
                    style={{
                      height: "30px",
                      boxShadow: "none",
                      width: "100%",
                      backgroundColor:
                        selectedDay == "Saturday"
                          ? themeStyle.primaryColor
                          : "white",

                      borderRadius: "3px",
                      fontWeight:
                        selectedDay == "Saturday" ? "bold" : "lighter",
                      color:
                        selectedDay == "Saturday"
                          ? "white"
                          : themeStyle.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedDay("Saturday");
                      setItemIndex(9999);
                    }}
                    variant={selectedDay == "Saturday" ? "contained" : ""}
                  >
                    Saturday
                  </Button>
                </Grid>
              </Grid>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                  width: "34%",
                }}
              >
                <Button
                  style={{
                    height: "30px",
                    boxShadow: "none",
                    width: "90%",
                    backgroundColor:
                      selectedDay == "Sunday"
                        ? themeStyle.primaryColor
                        : "white",

                    borderRadius: "3px",
                    marginLeft: "6px",
                    fontWeight: selectedDay == "Sunday" ? "bold" : "lighter",
                    color:
                      selectedDay == "Sunday"
                        ? "white"
                        : themeStyle.primaryColor,
                  }}
                  onClick={() => {
                    setSelectedDay("Sunday");
                    setItemIndex(9999);
                  }}
                  variant={selectedDay == "Sunday" ? "contained" : ""}
                >
                  Sunday
                </Button>
              </div>
            </Box>

            <Button
              onClick={() => updateTimeTable()}
              variant="contained"
              style={{
                width: "100%",
                marginTop: "15px",
                height: "35px",
                backgroundColor: themeStyle.primaryColor,
              }}
            >
              <h3>Update Timetable</h3>
            </Button>
            {isSubmitting ? (
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </div>
    );
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (isLoading) {
        return (
          <Fragment>
            <Sidebar />
            <div
              style={{
                borderRadius: "15px",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <Sidebar />
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={() => setOpen(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div
                  style={{
                    borderRadius: "15px",
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>
                    <h3>
                      Update Time Table for {" " + classs} {division}?
                    </h3>
                    <span>This action cannot be reversed.</span>
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={() => updateTimeTable()}
                        style={{ height: "30px" }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                      <Button
                        style={{ height: "30px", marginLeft: "10px" }}
                        variant="contained"
                        onClick={() => setOpen(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <div
              style={{
                borderRadius: "15px",
                margin: "65px 15px 20px 85px",
                backgroundColor: "white",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}
export default Timetable;
